import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
import { POKER_COLORS } from '../../theme/designSystem';

interface PokerButtonProps extends ButtonProps {
  variant?: 'primary' | 'secondary' | 'danger' | 'success';
}

const PokerButton: React.FC<PokerButtonProps> = ({ variant = 'primary', ...props }) => {
  const variantStyles = {
    primary: {
      bg: POKER_COLORS.cyan,
      color: POKER_COLORS.darkTeal,
      _hover: {
        bg: POKER_COLORS.accentCyan,
        transform: 'scale(1.02)',
        boxShadow: `0 0 20px ${POKER_COLORS.cyan}`,
      },
      _active: {
        transform: 'scale(0.98)',
      },
    },
    secondary: {
      bg: POKER_COLORS.darkTeal,
      color: POKER_COLORS.cyan,
      border: `2px solid ${POKER_COLORS.cyan}`,
      _hover: {
        boxShadow: `0 0 12px ${POKER_COLORS.cyan}`,
      },
    },
    danger: {
      bg: POKER_COLORS.darkRed,
      color: 'white',
      _hover: {
        bg: '#A00000',
        boxShadow: `0 0 12px ${POKER_COLORS.darkRed}`,
      },
    },
    success: {
      bg: POKER_COLORS.darkGreen,
      color: 'white',
      _hover: {
        bg: '#3E9B6F',
        boxShadow: `0 0 12px ${POKER_COLORS.darkGreen}`,
      },
    },
  };

  return <Button fontWeight="bold" borderRadius="8px" transition="all 0.2s" {...variantStyles[variant]} {...props} />;
};

export default PokerButton;
